// Quarks
import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';
import Text from 'quarks/Text';
import type { FlexProps } from 'quarks/interpolations/flex';

import ComponentButton from 'components/Button/ComponentButton';

import richTextParser from 'utils/richTextParser';

// Types
import type { ContentfulComponentTestimonial } from 'graphqlTypes';
import type { FC } from 'react';

interface TestimonialCardProps extends FlexProps, ContentfulComponentTestimonial {
  backgroundIsDark: boolean;
  isActive?: boolean;
  isDesc?: boolean;
}

const TestimonialCard: FC<TestimonialCardProps> = ({
  galleryHeading,
  galleryBody,
  callToAction,
  templateImage,
  backgroundIsDark,
  isActive,
  isDesc,
  ...props
}) => (
  <Flex position="relative" width="100%" flexDirection="column" gap="16px" {...props}>
    {!isDesc && templateImage && (
      <Container
        width="100%"
        height="100%"
        maxHeight="220px"
        borderRadius="20px"
        overflowX="hidden"
        overflowY="hidden"
        md={{ maxHeight: '435px' }}
      >
        <Image
          image={templateImage as ImageData}
          alt="Card Slider Image"
          objectFit="cover"
          objectPosition="top left"
          width="100%"
        />
      </Container>
    )}
    {isDesc && (
      <Flex flexDirection="column" gap="8px" transition="opacity 200ms ease-in-out" opacity={isActive ? '1' : '0'}>
        {galleryHeading && (
          <Flex width="100%" justifyContent="space-between" alignItems="center">
            <Text textStyle="textLg" fontWeight="semiBold" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
              {galleryHeading}
            </Text>
            {callToAction && (
              <Flex
                css={`
                  .MuiButton-root {
                    width: fit-content !important;
                  }
                `}
              >
                <ComponentButton {...callToAction} />
              </Flex>
            )}
          </Flex>
        )}
        {galleryBody && (
          <Flex
            textColor={backgroundIsDark ? 'gray-50' : 'gray-900'}
            fontFamily="secondaryFont"
            fontSize="textSm"
            lineHeight="textSm"
          >
            {richTextParser(galleryBody)}
          </Flex>
        )}
      </Flex>
    )}
  </Flex>
);

export default TestimonialCard;
